import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomToneOfVoice,
  BackendMutationUpdateCustomToneOfVoiceArgs,
} from 'src/types/backend';

import { FRAGMENT_CUSTOM_TONE_OF_VOICE } from './schema';

const MUTATION = gql`
  mutation UpdateCustomToneOfVoice(
    $id: ID!
    $name: String
    $description: String
    $defaultForGenerationTools: [GenerationToolEnum!]
    $traits: [Trait!]
    $personality: TovDefaultPresetEnum
  ) {
    updateCustomToneOfVoice(
      id: $id
      name: $name
      description: $description
      defaultForGenerationTools: $defaultForGenerationTools
      traits: $traits
      personality: $personality
    ) {
      ...CustomToneOfVoice
    }
  }

  ${FRAGMENT_CUSTOM_TONE_OF_VOICE}
`;

type Variables = Omit<BackendMutationUpdateCustomToneOfVoiceArgs, 'isDefault'>; // "isDefault" is deprecated on BE, but still present
type Result = BackendCustomToneOfVoice;

export const updateCustomToneOfVoice = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
